export class CivilStatus {
  static asArray: CivilStatus[] = [];

  public static readonly UNDEFINED = new CivilStatus("0", "Estado inicial");
  public static readonly SINGLE = new CivilStatus("1", "Soltero/a");
  public static readonly MARRIED = new CivilStatus("2", "Casado/a");
  public static readonly SEPARATED = new CivilStatus("3", "Separado/a");
  public static readonly WIDOWER = new CivilStatus("4", "Viudo/a");
  public static readonly FREE_UNION = new CivilStatus("5", "Unión Libre");

  static readonly LIST_CIVIL_STATUS = CivilStatus.asArray;

  static readonly STATUS_ABLE_RNEC = (status: string) =>
    [CivilStatus.MARRIED.codigo, CivilStatus.FREE_UNION.codigo].includes(
      status
    );

  constructor(readonly codigo: string, readonly desc: string) {
    CivilStatus.asArray.push(this);
  }
}
